import { createFileRoute } from '@tanstack/react-router'
import SendTransaction from "@/modules/sendTransaction";

export const Route = createFileRoute('/send-transaction')({
  component: SendTransaction,
})

